import React, {useState} from "react";
import Timeout from "../Timeout";
import moment from "moment/moment";
import {useLocaleContext} from "../../../../context/LocaleContext";
import ButtonClosePlayer from "../../../../blocks/PlayerBannerBlock/ButtonClosePlayer";

export default ({event, stream, onHidePlayer}) => {
    const {get} = useLocaleContext();
    const timeStart = moment.unix(stream?.timeStart);
    const [isTimeoutOver, setIsTimeoutOver] = useState(false);

    const onTimeoutOver = () => {
        setIsTimeoutOver(true);
    }

    return (
        <>
            {isTimeoutOver ? (
                <h1>{get('broadcast.overlay.starting.title')}</h1>
            ) : (
                <>
                    <h1>{get('broadcast.overlay.waiting.title')}</h1>
                    <Timeout time={timeStart} onTimeoutOver={onTimeoutOver} />
                </>
            )}

            <ButtonClosePlayer onClick={onHidePlayer} />
        </>
    );
}
